import { render } from "./CrearContratoCompraVenta.vue?vue&type=template&id=61054f6e"
import script from "./CrearContratoCompraVenta.vue?vue&type=script&lang=js"
export * from "./CrearContratoCompraVenta.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__